(ns machtfit.dashboard.stepchall.form.test-data
  (:require [machtfit.dashboard-widgets :as widgets]
            [re-frame.core :as rf]))

(defn section-test-data []
  (when @(rf/subscribe [:get [:io :show-test-data-form?]])
    [widgets/section
     {:anchor "test-data"
      :title "Test data"
      :content [:div
                [:div {:style {:display "inline-block"
                               :width "50%"}}
                 [:form {:action @(rf/subscribe [:get [:io :test-data-generate-activity-url]])
                         :method "post"
                         :encType "multipart/form-data"}
                  [:input {:type "hidden"
                           :name "csrfmiddlewaretoken"
                           :value @(rf/subscribe [:get [:io :csrf-token]])}]
                  [:p {:style {:margin-top 0}}
                   "Generate random activity for participants. If no start/end is given, then the whole challenge phase up to today is used."]
                  [widgets/date-input
                   {:value @(rf/subscribe [:get [:io :test-data :start]])
                    :on-save #(rf/dispatch [:set-path [:io :test-data :start] %])
                    :label-text "Start:"}]
                  [widgets/date-input
                   {:value @(rf/subscribe [:get [:io :test-data :end]])
                    :on-save #(rf/dispatch [:set-path [:io :test-data :end] %])
                    :label-text "End:"}]
                  [:button.btn.btn-primary {:type "submit"
                                            :name "action"
                                            :value "generate"}
                   "Generate Activity"]]]
                [:div {:style {:display "inline-block"
                               :width "50%"
                               :vertical-align "top"}}
                 [:p {:style {:margin-top 0}}
                  "Aggregate daily and total participant/team data."]
                 [:a.btn.btn-primary {:href @(rf/subscribe [:get [:io :test-data-aggregate-url]])}
                  "Aggregate"]]]}]))
